import React from 'react';
import { Container, Typography } from '@mui/material';

const Dashboard: React.FC = () => {
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1">
        Cab Driver Dashboard
      </Typography>
      {/* Implement cab driver dashboard */}
    </Container>
  );
};

export default Dashboard;
